import React from 'react'
import styled from 'styled-components'
import Pdfcontain from '../../../service/components/Pdfcontain'
import ProjectHeader from './ProjectHeader'

function SpecView(props) {
    var viewContract = props.viewContract
    var exdata = props.exdata
    var imageSrc = props.imageSrc
    var showExampleOverlay = props.showExampleOverlay
    var pg = props.pg
    var displayStep = props.displayStep

    return (
        <ViewRoot>
            {/* <ProjectHeader pg={pg} viewTitle={displayStep} /> */}
            <ProjectHeader pg={pg} viewTitle="사양서" />

            <TopSection>
                <Pdfcontain
                    top={false}
                    list={
                        viewContract && viewContract.specification ? viewContract.specification : exdata.specification
                    }
                    single={true}
                    type="specification"
                    types="only"
                    num={2}
                    mini={true}
                    file={imageSrc && imageSrc.base64 ? imageSrc.base64 : ''}
                    agree={false}
                    nums={2}
                    data={viewContract}
                />
            </TopSection>

            {showExampleOverlay ? <div className="text_absolute">사양서 예시입니다</div> : ''}
        </ViewRoot>
    )
}

export default SpecView

const ViewRoot = styled.div`
    width: 100%;
`

const TopSection = styled.div`
    margin-top: 0;
`
